__turbopack_context__.v({
  "areas": "TeamFocusAreasEdit-module-scss-module__MlaBLa__areas",
});
